import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import * as AdminSessionActions from "../../../state/redux/adminSession";
import * as ProviderSessionActions from "../../../state/redux/providerSession";
import { deepCopyObject } from "../../../utils/helpers";
import UserDialog from "../../dialogs/userDialog";
import SurveyProviders from "../../ui/surveyProviders";
import Widget from "../../ui/widget";
import WidgetSkeleton from "../../ui/widgetSkeleton";
import WidgetSurveyContent from "../../ui/widgetSurveyContent";
import WidgetTitle from "../../ui/widgetTitle";

const EmpireEmployees = props => {
  const {
    providerODMs,
    loadProvidersRequest,
    providerPageLoading,
    providerPagination,
    organizationODM,
  } = props;

  useEffect(() => {
    if (providerODMs != null) {
      setRows(providerODMs);
    }
  }, [providerODMs]);

  const [selectedProvider, setSelectedProvider] = useState(null);

  const [rows, setRows] = useState([]);

  const [titleText, setTitleText] = useState(null);

  useEffect(() => {
    if (providerPagination != null) {
      setTitleText(
        `${providerPagination.totalItems} User${providerPagination.totalItems === 1 ? "" : "s"}`,
      );
    } else {
      setTitleText("Loading...");
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [providerPagination]);

  return (
    <Widget>
      <WidgetTitle title={"Employees"} text={titleText}></WidgetTitle>

      {rows == null && <WidgetSkeleton />}
      {rows != null && (
        <WidgetSurveyContent>
          <SurveyProviders
            providerODMs={rows}
            onEditProvider={setSelectedProvider}
            onRequestNewPage={loadProvidersRequest}
            isLoading={providerPageLoading}
            providerPagination={providerPagination}
          />
        </WidgetSurveyContent>
      )}

      {selectedProvider && (
        <UserDialog
          open={selectedProvider != null}
          dialogTitle={`${selectedProvider._id == null ? "Add" : "Edit"} Provider`}
          omniODM={deepCopyObject(selectedProvider)}
          organizationType={organizationODM.omniData.organizationType}
          onDelete={provider_id => {
            props.deleteProviderRequest(provider_id);
            setSelectedProvider(null);
          }}
          onAccept={provider => {
            props.updateProviderRequest(provider);
            setSelectedProvider(null);
          }}
          onClose={() => {
            setSelectedProvider(null);
          }}
        />
      )}
    </Widget>
  );
};
const mapStateToProps = state => ({
  providerODMs: state.adminSession.providerODMs,
  providerPageLoading: state.adminSession.providerPageLoading,
  providerPagination: state.adminSession.providerPagination,
  organizationODM: state.userSession.organizationODM,
});

const mapDispatchToProps = {
  loadProvidersRequest: AdminSessionActions.loadProvidersRequest,

  deleteProviderRequest: ProviderSessionActions.deleteProviderRequest,
  setProviderODMRequest: ProviderSessionActions.setProviderODMRequest,
  updateProviderRequest: ProviderSessionActions.updateProviderRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EmpireEmployees));
